export enum SkillId {
  // Pre-purchase
  CHECKOUT_RECOVERY = "checkout-recovery",
  BROWSE_RECOVERY = "browse-recovery",
  WELCOME_MESSAGE = "welcome-message",
  PRICE_DROP_ALERT = "price-drop-alert",
  BACK_IN_STOCK = "back-in-stock",
  LOW_INVENTORY_ALERT = "low-inventory-alert",
  POST_RETURN_WINBACK = "post-return-winback",
  EXCHANGE_CREDIT_NUDGE = "exchange-credit-nudge",
  WARRANTY_FOLLOWUP = "warranty-followup",

  // Post-purchase — order lifecycle
  ORDER_CONFIRMATION = "order-confirmation",
  SHIPPING_NOTIFICATION = "shipping-notification",
  PRE_TRANSIT = "pre-transit",
  IN_TRANSIT = "in-transit",
  OUT_FOR_DELIVERY = "out-for-delivery",
  DELIVERY_FOLLOWUP = "delivery-followup",
  AVAILABLE_FOR_PICKUP = "available-for-pickup",

  // Post-purchase — issue / delay
  TRANSIT_DELAY_ALERT = "transit-delay-alert",
  STALLED_IN_FULFILLMENT = "stalled-in-fulfillment",
  DELIVERY_FAILURE = "delivery-failure",
  RETURN_TO_SENDER = "return-to-sender",
  SHIPMENT_CANCELLED = "shipment-cancelled",
  ARRIVING_EARLY = "arriving-early",

  // Post-purchase — engagement
  BRACKETING_DETECTION = "bracketing-detection",
  RETURN_INITIATION = "return-initiation",
  REVIEW_REQUEST = "review-request",
  CROSS_SELL = "cross-sell",

  // Shared
  SHOPPER_AI = "shopper-ai",
  ESCALATE_HELPDESK = "escalate-helpdesk",
  ORDER_LOOKUP = "order-lookup",
  RETURN_ELIGIBILITY = "return-eligibility",
}
